/**
 * Created by jonas on 2022-06-15.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GfxUtils} from "../utils/GfxUtils";
import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";
import {KitchenDramaSushiManiaStatics} from "../utils/KitchenDramaSushiManiaStatics";

export class SushiFsMeterView extends PIXI.Container implements StageLayer {
    private view:PIXI.Container;

    constructor() {
        super();
        this.name = "SushiFsMeterView"
        this.init();
    }

    private init() {
        this.view = new PIXI.Container();

        this.createMeterGfx();
        this.createTransformMovieClips();
        this.resetGraphics();

        this.addChild(this.view);
        this.onResize();
    }


    public show() {
        this.view.visible = true;
    }

    public hide() {
        this.view.visible = false;
        this.resetGraphics();
        this._currentLevel = 0;
    }




    static UPDATE_LEVEL_ANIMATION:string = "KitchenDramaSushiCollectView_updateLevelAnimation";
    static SET_LEVEL:string = "KitchenDramaSushiCollectView_setLevel";

    private _currentLevel:number = 0;


    private _staticContainer:PIXI.Container;


    private _meterLevelPositions:number[] =
        [
            560, //Bottom = empty
            491,
            434,
            362, //First major separator
            306,
            249,
            182, //Second major separator
            126,
            69,
            0//top = full


        ];

    private _transformAnimationYpos:number[] =
        [
            180,
            345,
            510
        ];

    private _fillMask:PIXI.Graphics;
    private _arrow:PIXI.Sprite;
    private _meterFill:PIXI.Sprite;
    private _meterFillWhite:PIXI.Sprite;
    private _fillMaskWhite:PIXI.Graphics;
    private _whiteOutContainer:PIXI.Container;
    private _transformMovieClipTop:TimelineSprite;
    private _transformMovieClipMiddle:TimelineSprite;
    private _transformMovieClipBottom:TimelineSprite;
    private _salmonNoLegs:PIXI.Sprite;
    private _salmonNoLegsMini:PIXI.Sprite;
    private _riceNoLegs:PIXI.Sprite;
    private _riceNoLegsMini:PIXI.Sprite;
    private _soyNoLegs:PIXI.Sprite;
    private _soyNoLegsMini:PIXI.Sprite;
    private _meterTopContainer:PIXI.Container;
    private _meterMiddleContainer:PIXI.Container;
    private _meterBottomContainer:PIXI.Container;
    private _meterLogo:PIXI.Sprite;
    private _meterAttentionBottom:TimelineSprite;
    private _meterAttentionMiddle:TimelineSprite;
    private _meterAttentionTop:TimelineSprite;
    private _meterBackplate:PIXI.Sprite;


    /*
        protected addEventListeners() {
            EventHandler.addEventListener(this, SushiFsMeterView.ADD_TO_STAGE, (event:GameEvent) => this.onAddToStage());
            EventHandler.addEventListener(this, SushiFsMeterView.REMOVE_FROM_STAGE, () => this.onRemoveFromStage());
            EventHandler.addEventListener(this, SushiFsMeterView.UPDATE_LEVEL_ANIMATION, (event:GameEvent) => this.updateLevelAnimation(event.params[0]));
            EventHandler.addEventListener(this, SushiFsMeterView.SET_LEVEL, (event:GameEvent) => this.setLevel(event.params[0]));
        }
    */

    private createTransformMovieClips() {
        let position:PIXI.Point = new PIXI.Point(0, -15);
        let anchor:PIXI.Point = new PIXI.Point(0.5, 0.5);

        //Top
        this._meterTopContainer = new PIXI.Container();
        this._meterTopContainer.position.set(118, this._transformAnimationYpos[0]);

        this._salmonNoLegs = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_SALMON_NO_LEGS, position, anchor);
        this._salmonNoLegsMini = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_SALMON_NO_LEGS_MINI, new PIXI.Point(-45, -70), anchor);

        this._transformMovieClipTop = GfxUtils.createTimelineSprite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_TRANSFORM_SYMBOL);
        this._meterAttentionTop = GfxUtils.createAttentionTimelineSprite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_ATTENTION);

        this._meterTopContainer.addChild(this._salmonNoLegs);
        this._meterTopContainer.addChild(this._transformMovieClipTop);
        this._meterTopContainer.addChild(this._salmonNoLegsMini);
        this._meterTopContainer.addChild(this._meterAttentionTop);

        //Middle
        this._meterMiddleContainer = new PIXI.Container();
        this._meterMiddleContainer.position.set(118, this._transformAnimationYpos[1]);

        this._riceNoLegs = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_RICE_NO_LEGS, position, anchor);
        this._riceNoLegsMini = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_RICE_NO_LEGS_MINI, new PIXI.Point(-45, -70), anchor);


        this._transformMovieClipMiddle = GfxUtils.createTimelineSprite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_TRANSFORM_SYMBOL);
        this._meterAttentionMiddle = GfxUtils.createAttentionTimelineSprite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_ATTENTION);

        this._meterMiddleContainer.addChild(this._riceNoLegs);
        this._meterMiddleContainer.addChild(this._transformMovieClipMiddle);
        this._meterMiddleContainer.addChild(this._riceNoLegsMini);
        this._meterMiddleContainer.addChild(this._meterAttentionMiddle);


        //bottom
        this._meterBottomContainer = new PIXI.Container();
        this._meterBottomContainer.position.set(118, this._transformAnimationYpos[2]);

        this._soyNoLegs = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_SOY_NO_LEGS, position, anchor);
        this._soyNoLegsMini = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_SOY_NO_LEGS_MINI, new PIXI.Point(-45, -70), anchor);

        this._transformMovieClipBottom = GfxUtils.createTimelineSprite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_TRANSFORM_SYMBOL);
        this._meterAttentionBottom = GfxUtils.createAttentionTimelineSprite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_ATTENTION);

        this._meterBottomContainer.addChild(this._soyNoLegs);
        this._meterBottomContainer.addChild(this._transformMovieClipBottom);
        this._meterBottomContainer.addChild(this._soyNoLegsMini);
        this._meterBottomContainer.addChild(this._meterAttentionBottom);


        this.view.addChild(this._meterTopContainer);
        this.view.addChild(this._meterMiddleContainer);
        this.view.addChild(this._meterBottomContainer);
    }

    private resetGraphics() {
        this._meterFillWhite.alpha = 0;
        this._fillMask.position.set(0, this._meterLevelPositions[0]);
        this._fillMaskWhite.position.set(0, this._meterLevelPositions[0]);
        this._arrow.position.set(135, this._meterLevelPositions[0]);

        this._transformMovieClipTop.hide();
        this._transformMovieClipMiddle.hide();
        this._transformMovieClipBottom.hide();
        this._meterAttentionBottom.hide();
        this._meterAttentionMiddle.hide();
        this._meterAttentionTop.hide();

        this._transformMovieClipTop.getAnimation().pause(0, false);
        this._transformMovieClipMiddle.getAnimation().pause(0, false);
        this._transformMovieClipBottom.getAnimation().pause(0, false);
        this._meterAttentionBottom.getAnimation().pause(0, false);
        this._meterAttentionMiddle.getAnimation().pause(0, false);
        this._meterAttentionTop.getAnimation().pause(0, false);

        this._salmonNoLegs.scale.set(0.5, 0.5);
        this._riceNoLegs.scale.set(0.5, 0.5);
        this._soyNoLegs.scale.set(0.5, 0.5);

        this._salmonNoLegsMini.scale.set(0.0, 0.0);
        this._riceNoLegsMini.scale.set(0.0, 0.0);
        this._soyNoLegsMini.scale.set(0.0, 0.0);
    }

    private createMeterGfx() {

        this._staticContainer = new PIXI.Container();
        this._staticContainer.position.set(85, 73);
        this._staticContainer.scale.set(0.9, 0.9);

        this._whiteOutContainer = new PIXI.Container();
        //Logo
        this._meterLogo = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_LOGO, new PIXI.Point(85, -18), new PIXI.Point(0.5, 0.5));
        this._staticContainer.addChild(this._meterLogo);

        //Backplate
        this._meterBackplate = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_BACK_PLATE);
        this._staticContainer.addChild(this._meterBackplate);

        //Fill
        this._meterFill = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_FILL);
        this._staticContainer.addChild(this._meterFill);


        //Fill White
        this._meterFillWhite = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_FILL_WHITE);
        this._whiteOutContainer.addChild(this._meterFillWhite);


        //Fill mask
        this._fillMask = new PIXI.Graphics();
        this._fillMask.beginFill(0xFFFFFF);
        this._fillMask.drawRect(0, 0, this._meterFill.width, this._meterFill.height);
        this._fillMask.endFill();

        this._staticContainer.addChild(this._fillMask);
        this._meterFill.mask = this._fillMask;


        //Fill mask white
        this._fillMaskWhite = new PIXI.Graphics();
        this._fillMaskWhite.beginFill(0xFFFFFF);
        this._fillMaskWhite.drawRect(0, 0, this._meterFillWhite.width, this._meterFillWhite.height);
        this._fillMaskWhite.endFill();
        this._meterFillWhite.mask = this._fillMaskWhite;
        this._whiteOutContainer.addChild(this._fillMaskWhite);
        this._staticContainer.addChild(this._whiteOutContainer);


        //Arrow
        this._arrow = GfxUtils.createSpite(KitchenDramaSushiManiaGameAssets.FS_SUSHI_METER_ARROW);
        this._arrow.anchor.set(0, 0.5);
        this._staticContainer.addChild(this._arrow);


        this.view.addChild(this._staticContainer);
    }


    public updateLevelAnimation(newLevel:number,  contributingSymbols:boolean[]):gsap.core.Timeline {
        let updateTimeline = gsap.timeline();

        let oldLevel:number = this._currentLevel;

        //Clamp level to top
        newLevel = Math.min(newLevel, this._meterLevelPositions.length - 1);

        //Should animate check
        if (oldLevel == newLevel) {
            Logger.logDev("Same level, skipping multiplier animation");
            return updateTimeline;
        }


        updateTimeline = this.createUpdateTimeLine(newLevel, oldLevel, contributingSymbols);
        this._currentLevel = newLevel;

        return updateTimeline;
    }

    public setLevel(newLevel:number) {
        let newLevelY = this._meterLevelPositions[newLevel];
        let arrowNewLevelY:number = newLevelY + 8;
        this._fillMask.position.y = newLevelY;
        this._fillMaskWhite.position.y = newLevelY;
        this._arrow.position.y = newLevelY;

        if (newLevel >= 3) {
            this._soyNoLegs.scale.set(0, 0);
            this._transformMovieClipBottom.visible = true;
            this._transformMovieClipBottom.getAnimation().pause(this._transformMovieClipBottom.totalDuration, false);
            this._soyNoLegsMini.scale.set(1, 1);
            this._arrow.position.y = arrowNewLevelY;


        }

        if (newLevel >= 6) {
            this._riceNoLegs.scale.set(0, 0);
            this._transformMovieClipMiddle.visible = true;
            this._transformMovieClipMiddle.getAnimation().pause(this._transformMovieClipMiddle.totalDuration, false);
            this._riceNoLegsMini.scale.set(1, 1);
            this._arrow.position.y = arrowNewLevelY;
        }

        if (newLevel >= 9) {
            this._salmonNoLegs.scale.set(0, 0);
            this._transformMovieClipTop.visible = true;
            this._transformMovieClipTop.getAnimation().pause(this._transformMovieClipTop.totalDuration, false);
            this._salmonNoLegsMini.scale.set(1, 1);
            this._arrow.position.y = arrowNewLevelY;
        }

        this._currentLevel = newLevel;

    }

    private createUpdateTimeLine(newLevel:number, oldLevel:number, contributingSymbols:boolean[]):gsap.core.Timeline {

        let newLevelY = this._meterLevelPositions[newLevel];
        let arrowNewLevelY:number = newLevelY;
        //let oldLevelY = this._meterLevelPositions[oldLevel];

        let tl:gsap.core.Timeline = gsap.timeline();

        if (newLevel === 3) {
            arrowNewLevelY = newLevelY + 8;

        } else if (newLevel === 6) {
            arrowNewLevelY = newLevelY + 8;

        } else if (newLevel === 9) {
            arrowNewLevelY = newLevelY + 8;
        } else {
            arrowNewLevelY = newLevelY;
        }


        let soundStartTime = tl.totalDuration();


        let meterLevelsCenter = newLevelY + (this._meterLevelPositions[0] - newLevelY) * 0.5;
        this._whiteOutContainer.pivot.set(136, meterLevelsCenter);
        this._whiteOutContainer.position.set(136, meterLevelsCenter);

        //Fill meter

        tl.add([
               gsap.to(this._fillMask.position,  {duration:0.185, ease:KitchenDramaSushiManiaStatics.WHIP_EASE, y:newLevelY}),
               gsap.to(this._fillMaskWhite.position,  {
                    duration:0.185,
                    ease:KitchenDramaSushiManiaStatics.WHIP_EASE,
                    y:newLevelY
                }),
               gsap.to(this._arrow.position, {
                    duration:0.185,
                    ease:KitchenDramaSushiManiaStatics.WHIP_EASE,
                    y:arrowNewLevelY
                }),
            ]
        );

        tl.add(gsap.to(this._arrow.scale, {duration:0.1, ease:"none", x:1.2, y:1.2}), "-= 0.05");
        tl.add(gsap.to(this._arrow.scale, {duration:0.1, ease:"none", x:1.0, y:1.0}));

        //Flash white out
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:1.0}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.0}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.8}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.0}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.6}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.0}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.4}));
        tl.add(gsap.to(this._meterFillWhite, {duration:0.1, alpha:0.0}));


        let noLegsEasing = "back.inOut.config(3)";
        let majorLevelTimline:gsap.core.Timeline;
        //Add major level animations.
        if (newLevel >= 3 && oldLevel < 3) {
            //First major level
            majorLevelTimline = gsap.timeline();
            majorLevelTimline.add(gsap.to(this._soyNoLegs.scale, {duration:0.2, x:0.3, y:0.6, ease:noLegsEasing}));
            majorLevelTimline.add(gsap.to(this._soyNoLegs.scale, {duration:0.1, x:0.0, y:0.0, ease:noLegsEasing}));
            majorLevelTimline.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_TURN_INTO_WILD));
            majorLevelTimline.add(() => this._transformMovieClipBottom.show());
            majorLevelTimline.add(this._transformMovieClipBottom.getAnimation().play());
            majorLevelTimline.add(gsap.to(this._soyNoLegsMini.scale, {
                duration:0.7,
                x:1.0,
                y:1.0,
                ease:"elastic.out"
            }), majorLevelTimline.totalDuration() - 0.4);
            tl.add(majorLevelTimline, tl.totalDuration() - 0.5);
            tl.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_REACH_BAR), soundStartTime);
        } else if (newLevel >= 6 && oldLevel < 6) {
            //Second major switched to active.
            majorLevelTimline = gsap.timeline();
            majorLevelTimline.add(gsap.to(this._riceNoLegs.scale, {duration:0.2,x:0.3, y:0.6, ease:noLegsEasing}));
            majorLevelTimline.add(gsap.to(this._riceNoLegs.scale, {duration:0.1,x:0.0, y:0.0, ease:noLegsEasing}));
            majorLevelTimline.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_TURN_INTO_WILD));
            majorLevelTimline.add(() => this._transformMovieClipMiddle.show());
            majorLevelTimline.add(this._transformMovieClipMiddle.getAnimation().play());
            majorLevelTimline.add(gsap.to(this._riceNoLegsMini.scale, {
                duration:0.7,
                x:1.0,
                y:1.0,
                ease:"elastic.out"
            }), majorLevelTimline.totalDuration() - 0.4);
            tl.add(majorLevelTimline, tl.totalDuration() - 0.5);

            tl.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_REACH_BAR), soundStartTime);
        } else if (newLevel >= 9 && oldLevel < 9) {
            //Top reached
            majorLevelTimline = gsap.timeline();
            majorLevelTimline.add(gsap.to(this._salmonNoLegs.scale, {
                duration:0.2,
                x:0.3,
                y:0.6,
                ease:noLegsEasing
            }));
            majorLevelTimline.add(gsap.to(this._salmonNoLegs.scale, {
                duration:0.1,
                x:0.0,
                y:0.0,
                ease:noLegsEasing
            }));
            majorLevelTimline.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_TURN_INTO_WILD));
            majorLevelTimline.add(() => this._transformMovieClipTop.show());
            majorLevelTimline.add(this._transformMovieClipTop.getAnimation().play());
            majorLevelTimline.add(gsap.to(this._salmonNoLegsMini.scale, {
                duration:0.7,
                x:1.0,
                y:1.0,
                ease:"elastic.out"
            }), majorLevelTimline.totalDuration() - 0.4);
            tl.add(majorLevelTimline, tl.totalDuration() - 0.5);
            tl.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_REACH_BAR), soundStartTime);
        } else {
            tl.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_METER_UP), soundStartTime);
        }


        //Glitter effect on contributing symbols.
        if (contributingSymbols[0]) {
            tl.add(() => this._meterAttentionBottom.show(), 0);
            tl.add(this._meterAttentionBottom.getAnimation().play(), 0);
            tl.add(() => this._meterAttentionBottom.hide(), this._meterAttentionBottom.totalDuration);
        }

        if (contributingSymbols[1]) {
            tl.add(() => this._meterAttentionMiddle.show(), 0);
            tl.add(this._meterAttentionMiddle.getAnimation().play(), 0);
            tl.add(() => this._meterAttentionMiddle.hide(), this._meterAttentionMiddle.totalDuration);
        }

        if (contributingSymbols[2]) {
            tl.add(() => this._meterAttentionTop.show(), 0);
            tl.add(this._meterAttentionTop.getAnimation().play(), 0);
            tl.add(() => this._meterAttentionTop.hide(), this._meterAttentionTop.totalDuration);

        }

        return tl;
    }

    public onResize() {
        if (!NolimitApplication.isLandscape) {
            //rotate meter
            this.view.rotation = 90 * (Math.PI / 180);
            this.view.position.set(680,-146);
            //this.position.set(620, -115);
            //this.scale.set(0.8);

            this._staticContainer.addChild(this._meterLogo);
            this._meterLogo.rotation = -90 * PIXI.DEG_TO_RAD;
            this._meterLogo.position.set(0, 285);
            this._meterTopContainer.rotation = -90 * PIXI.DEG_TO_RAD;
            this._meterTopContainer.position.set(155, this._transformAnimationYpos[0] - 5);
            this._meterBottomContainer.rotation = -90 * PIXI.DEG_TO_RAD;
            this._meterBottomContainer.position.set(155, this._transformAnimationYpos[2] - 5);
            this._meterMiddleContainer.rotation = -90 * PIXI.DEG_TO_RAD;
            this._meterMiddleContainer.position.set(155, this._transformAnimationYpos[1] - 5);
        } else {
            this.view.rotation = 0;
            this.view.position.set(-270,24);
            //this.position.set(6, 34);
            //this.scale.set(0.9);

            this._staticContainer.addChildAt(this._meterLogo, 0);
            this._meterLogo.rotation = 0;
            this._meterLogo.position.set(85, -18);
            this._meterTopContainer.rotation = 0;
            this._meterTopContainer.position.set(118, this._transformAnimationYpos[0] - 5);
            this._meterBottomContainer.rotation = 0;
            this._meterBottomContainer.position.set(118, this._transformAnimationYpos[2] - 5);
            this._meterMiddleContainer.rotation = 0;
            this._meterMiddleContainer.position.set(118, this._transformAnimationYpos[1] - 5);
        }
    }


}